const isDevelopment = process.env.NODE_ENV !== 'production';

export const logger = {
  debug: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Always log errors
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};

export default logger;
